// The calc job stores 0.03531 x the daily totalizer delta in m3, i.e. thousand cubic feet.
export const GAS_UNIT = "Mscf";

export interface GasRow {
	Value: number;
	Date: string;
}

export interface GasConsumptionData {
	rows: GasRow[];
	total: number;
	max: number;
}
